import React from 'react';
import './Footer.less';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p className="copyright-text">
          © {currentYear} React TypeScript 应用. 💗杨小杨 保留所有权利.
        </p>
      </div>
    </footer>
  );
};

export default Footer;